import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/clarity-static.css'
import { captureUTMParameters } from './lib/analytics'

// Capture UTM parameters on first page load for attribution tracking
captureUTMParameters();

createRoot(document.getElementById("root")!).render(<App />);
